'use strict';
/*!
 * for Pickup entry slider Block
 *
 * @package tokai-univ
 * @deps swiper
 */

let isEsReady = false;

document.addEventListener( 'readystatechange', () => {
	// Already enabled.
	if ( isEsReady ) {
		return;
	}
	// If not enabled, check if DOM is ready.
	switch ( document.readyState ) {
		case 'loading':
			return;
		default:
			isEsReady = true;
			break;
	}
	const esSliders = document.querySelectorAll( '.js-swiper-entry-slider' );
	const esSlidersArray = Array.prototype.slice.call( esSliders );
	if ( esSliders.length ) {
		esSlidersArray.forEach( function ( esSliderElement, index ) {
			const esSlideElm = esSliderElement.querySelectorAll( '.swiper-container' );
			const esSlidePagi = esSliderElement.querySelectorAll( '.swiper-pagination' );
			const esSlidePrevBtn = esSliderElement.querySelectorAll( '.swiper-button-prev' );
			const esSlideNextBtn = esSliderElement.querySelectorAll( '.swiper-button-next' );
			esSlideElm[0].classList.add( 'esSliderInstance-' + index );
			esSlidePagi[0].classList.add( 'esPagination-' + index );
			esSlidePrevBtn[0].classList.add( 'esSliderPrevBtn-' + index );
			esSlideNextBtn[0].classList.add( 'esSliderNextBtn-' + index );
			//swiper initialize
			new Swiper( '.esSliderInstance-' + index, {
				loop: true,
				uniqueNavElements: false,
				slidesPerView: 1,
				centeredSlides: true,
				effect: 'coverflow',
				coverflowEffect: {
					rotate: 0,
					stretch: 0,
					depth: 0,
					modifier: 1,
					slideShadows: false,
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 0,
						coverflowEffect: {
							rotate: 0,
							stretch: 150,
							depth: 300,
							modifier: 1,
							slideShadows: false,
						},
					},
				},
				pagination: {
					el: '.esPagination-' + index,
					clickable: true,
				},
				navigation: {
					nextEl: '.esSliderNextBtn-' + index,
					prevEl: '.esSliderPrevBtn-' + index,
				},
				autoplay: {
					delay: 8000,
				},
				a11y: {
					prevSlideMessage: '前の投稿 - Previous entry',
					nextSlideMessage: '次の投稿 - Next entry',
				},
			} );
		} );
	}
} );
